import { useNavigate } from 'react-router';

export const useLogout = () => {
  const navigate = useNavigate();
  return () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };
};
